module.exports = __webpack_public_path__ + "static/media/sugata_logo.4b98c777.gif";